import React, { Component } from "react";
import "../App.css";
import { fetchAuthSession } from "@aws-amplify/auth";
import Utils from './../utils.js';

class RequestsApproverNewProxy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      virtualPath: "",
      targetPath: "",
      deploymentEnvironment: "",
      buildEnvironment: "",
      proxyGroupName: "",
      subBU: "",
      adGroup: "",
      requestor: "",
      createdAt: "",
      requestorEmail: "",
      buildUrl: "",
      adGroupMembers: "",
      approverError: false,
      approverValidError: false,
      approverSubmitted: false,
      denialSubmitted: false,
      loggedInUser: "",
      isVisible: true,
      setIsVisible: false,
      requestSubmitted: false,
      isExpired: false,
      isFutureTime: false,
      requestDenied: false,
      requestFailed: false,
      approvedBy:"",
      deniedBy: "",
      adminEmails: "",
      domainName: "",
      skippedBuildEnvironment: "",
      isNewProduct: false
    };
    //Split the url alone
    this.URL = window.location.href.split("#")[0];
  }

  componentDidUpdate() {

  }

  componentDidMount() {

    this.consumeQueryParams();
  }

  validateRequest = async () => {

    let data = this.getStore();

    //API call
     let fetchAPIResponse  = {};
    try{
       let buildBody = {};
       buildBody = {
        status: Utils.FETCH_STATUS,
        buildUrl: data.buildUrl,
      };
        fetchAPIResponse = await Utils.approvalStatusAPICall(data, buildBody, "Create New Proxy API", "/create-new-proxy");

    }catch(error){
        // Fetching details from lambda failed
      this.setState({ requestFailed: true, isVisible: true });
      return;
    }
    if (fetchAPIResponse.status === Utils.APPROVED && (fetchAPIResponse.status !== Utils.DENIED || fetchAPIResponse.status !== Utils.FAILED)) {
      // if request is aready submitted
      this.setState({ approvedBy: fetchAPIResponse.approvedBy});
      this.setState({ requestDenied: false, isVisible: true });
      this.setState({ requestSubmitted: true, isVisible: true });
      return;
    } else if (fetchAPIResponse.status === Utils.DENIED && (fetchAPIResponse.status !== Utils.APPROVED || fetchAPIResponse.status !== Utils.FAILED)) {
      // if request is aready Denied
        this.setState({ deniedBy: fetchAPIResponse.deniedBy});
      this.setState({ requestSubmitted: false, isVisible: true });
      this.setState({ requestDenied: true, isVisible: true });
      return;
    } else if (fetchAPIResponse.status === Utils.FAILED) {
      // Fetching details from lambda failed
      this.setState({ requestFailed: true, isVisible: true });
      return;
    } else {

      const createdAtIntForm = parseInt(data.createdAt, 10);
      const createAtDate = new Date(createdAtIntForm);

      //To check if requst timestamp is not future date
      const isFutureDate = Utils.isFutureTimestamp(createAtDate);

      if(isFutureDate){
        this.setState({isFutureTime:true, isVisible: true });
        return;
      }
      var diffDays = Utils.isRequestExpired(createAtDate);

      if (diffDays > 3) {
        this.setState({ isExpired: true, isVisible: true });
        return;
      }
      if (data.requestorEmail === data.loggedInUser) {
        this.setState({ approverError: true, isVisible: true });
        return;
      } else if(data.adminEmails.includes(data.loggedInUser) ){
        this.setState({ approverValidError: false, isVisible: false });
        return;
      } else if (!data.adGroupMembers.includes(data.loggedInUser)) {
        this.setState({ approverValidError: true, isVisible: true });
        return;
      }
    }
    this.setState({  isVisible: false });
    //ReachedHere- request is available for user action
  };

  consumeQueryParams = async () => {

    const cognitoUserSession = await fetchAuthSession();
    const loggedInUser = cognitoUserSession.tokens.idToken.payload.email;
    let queryparamsJson = Utils.retrieveQueryParams();

    if(queryparamsJson){
      await this.setState({
        virtualPath: queryparamsJson.virtualPath,
        targetPath: queryparamsJson.targetPath,
        deploymentEnvironment: queryparamsJson.deploymentEnvironment,
        buildEnvironment: queryparamsJson.buildEnvironment,
        subBU: queryparamsJson.subBU,
        adGroup: queryparamsJson.adGroup,
        proxyGroupName: queryparamsJson.proxyGroupName,
        requestor: queryparamsJson.requestor,
        createdAt: queryparamsJson.createdAt,
        requestorEmail: queryparamsJson.requestorEmail,
        buildUrl: queryparamsJson.buildUrl,
        adGroupMembers: queryparamsJson.adGroupMembers,
        loggedInUser: loggedInUser,
        adminEmails: queryparamsJson.adminEmails,
        domainName: queryparamsJson.domainName,
        skippedBuildEnvironment: queryparamsJson.skippedBuildEnvironment,
        isNewProduct: queryparamsJson.isNewProduct
      });
    }

    this.validateRequest();

  };

  approveFunction = async () => {
    this.setState({ isVisible: true });
    let data = this.getStore();
    var approveAPIResponse = {};
    // Call new lambda function to submit the approval request

    let buildBody = {};
    buildBody = {
        virtualPath: data.virtualPath,
        targetPath: data.targetPath,
        proxyGroupName: data.proxyGroupName,
        deploymentEnvironment: data.deploymentEnvironment,
        buildEnvironment: data.buildEnvironment,
        subBU: data.subBU,
        adGroup: data.adGroup,
        status: Utils.APPROVAL,
        buildUrl: data.buildUrl,
        requestor: data.requestor,
        skippedBuildEnvironment: data.skippedBuildEnvironment,
        isNewProduct: data.isNewProduct
      };
    approveAPIResponse = await Utils.approvalStatusAPICall(data, buildBody, "Create New Proxy API", "/create-new-proxy");

    if (approveAPIResponse.status === Utils.APPROVED) {

      this.setState({ approverSubmitted: true, isVisible: true });
      return;
    } else if (approveAPIResponse.status === Utils.FAILED){

      this.setState({ requestFailed: false, isVisible: false });
    }
  };

  denyFunction = async () => {
    this.setState({ isVisible: true });
    let data = this.getStore();
    //this.setState({ approverValidError: false, isVisible: true });
    // Call new lambda function to submit the approval request
    let buildBody = {};
    var denyAPIResponse = "";
    buildBody = {
        virtualPath: data.virtualPath,
        targetPath: data.targetPath,
        proxyGroupName: data.proxyGroupName,
        deploymentEnvironment: data.deploymentEnvironment,
        buildEnvironment: data.buildEnvironment,
        subBU: data.subBU,
        adGroup: data.adGroup,
        status: Utils.DENIAL,
        buildUrl: data.buildUrl,
        requestor: data.requestor,
        skippedBuildEnvironment: data.skippedBuildEnvironment,
        isNewProduct: data.isNewProduct
      };
    denyAPIResponse = await Utils.approvalStatusAPICall(data, buildBody, "Create New Proxy API", "/create-new-proxy");

    if (denyAPIResponse.status === Utils.DENIED) {

      this.setState({ denialSubmitted: true, isVisible: true });
      return;
    } if (denyAPIResponse.status === Utils.FAILED) {

      this.setState({ requestFailed: true, isVisible: false });
      return;
    } else {

      this.setState({ denialSubmitted: false, isVisible: false });
    }
  };

  getStore = () => {
    return this.state;
  };

  render() {
    let data = this.getStore();

    return (
      <div>
        <h4>Create New Proxy Approval</h4>

        <div className="container util-margin-top-50">
          <hr />
          <div className="row">
            <div className="col-md-3">
              <span>Virtual Path: </span>
            </div>
            <div className="col-md-6">
              <span>{data.virtualPath}</span>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3">
              <span>Target Path: </span>
            </div>
            <div className="col-md-6">
              <span>{data.targetPath}</span>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3">
              <span>Deployment Environment: </span>
            </div>
            <div className="col-md-6">
              <span>{data.deploymentEnvironment}</span>
            </div>
          </div>
           <hr />
          <div className="row">
            <div className="col-md-3">
              <span>Build Environment: </span>
            </div>
            <div className="col-md-6">
              <span>{data.buildEnvironment}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Build URL: </span>
            </div>
            <div className="col-md-6">
               <a href={data.buildUrl} target="_blank" rel="noopener noreferrer">{data.buildUrl} </a>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3">
              <span>SubBU: </span>
            </div>
            <div className="col-md-6">
              <span>{data.subBU}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>AD Group: </span>
            </div>
            <div className="col-md-6">
              <span>{data.adGroup}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Proxy Group Name: </span>
            </div>
            <div className="col-md-6">
              <span>{data.proxyGroupName}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Requestor: </span>
            </div>
            <div className="col-md-6">
              <span>{data.requestorEmail}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Approvers: </span>
            </div>
            <div className="col-md-6">
              <span>{data.adGroupMembers}</span>
            </div>
          </div>
        </div>

        <hr />
        <div>
          <button
            disabled={this.state.isVisible}
            className="btn btn-primary btn-sm pull-left"
            onClick={this.approveFunction}
          >
            Approve
          </button>
          <button style={{"marginLeft":"10px"}}
            disabled={this.state.isVisible}
            className="btn btn-primary btn-sm pull-left"
            onClick={this.denyFunction}
          >
            Deny
          </button>
        </div>

        <br />
        <br />
        {this.state.approverError && (
          <p className="alert alert-danger util-margin-top-10">
            Requestor and approver cannot be same.{this.state.approverError}
          </p>
        )}
        {this.state.approverValidError && (
          <p className="alert alert-danger util-margin-top-10">
            User is not part of the AD Group and cannot approve this request.
            {this.state.approverValidError}
          </p>
        )}
        {this.state.approverSubmitted && (
          <p className="alert alert-success util-margin-top-10">
            Approval Request has been successfully submitted, you will receive an email of its status.
            {this.state.approverSubmitted}
          </p>
        )}
        {this.state.requestSubmitted && (
          <p className="alert alert-success util-margin-top-10">
            This request is already approved by {data.approvedBy}, No action is required.
            {this.state.requestSubmitted}
          </p>
        )}
        {this.state.denialSubmitted && (
          <p className="alert alert-success util-margin-top-10">
            Denial Request has been successfully submitted.{this.state.denialSubmitted}
          </p>
        )}
        {this.state.isExpired && (
          <p className="alert alert-danger util-margin-top-10">
            This request is expired.{this.state.isExpired}
          </p>
        )}
         {this.state.requestDenied && (
          <p className="alert alert-danger util-margin-top-10">
            This request is already denied by {data.deniedBy}, No action is required.{this.state.requestDenied}
          </p>
        )}
        {this.state.requestFailed && (
          <p className="alert alert-danger util-margin-top-10">
            Calling the API is failed, refresh the page and try again.{this.state.requestFailed}
          </p>
        )}
        {this.state.isFutureTime && (
          <p className="alert alert-danger util-margin-top-10">
            Resuested Date cannot be a future date.{this.state.isFutureTime}
          </p>
        )}
      </div>
    );
  }
}

export default RequestsApproverNewProxy;
